import React from "react";
import {Modal, Text, TextAs, TextSizes} from "@clockout-dev/design-elements";
import MemberSearch from "./audit/MemberSearch";
import styles from "../styles/document-audit.module.scss";

/**
 * "Load from member…" modal for the composer's preset bar: the same member
 * search the audit tab uses; picking a member pulls their real SOR into the
 * composer (the controller owns the fetch/apply/close flow).
 *
 * @param {Object} props
 * @param {boolean} props.open
 * @param {boolean} [props.loading] — a member SOR fetch is in flight
 * @param {string} props.query
 * @param {{clientId: string, name: string, email: string}[]} props.results
 * @param {boolean} props.searchLoading
 * @param {(term: string) => void} props.onSearch
 * @param {(member: object) => void} props.onSelect
 * @param {() => void} props.onClose
 */
function MemberSorModal({open, loading = false, query, results, searchLoading, onSearch, onSelect, onClose}) {
    return (
        <Modal open={open} onCancel={onClose} footer={null} title="Load SOR from member" destroyOnHidden width={560}>
            <div className={styles.modalBody}>
                <Text as={TextAs.P} size={TextSizes.EXTRA_SMALL} className={styles.modalHint}>
                    Pick a member to pull their real system-of-record into the composer. It replaces the authored SOR (dollars, same schema) and stays unsaved until you save it as a preset.
                </Text>
                <MemberSearch query={query} results={results} loading={searchLoading} busy={loading} onSearch={onSearch} onSelect={onSelect} />
                {loading ? (
                    <Text as={TextAs.P} size={TextSizes.EXTRA_SMALL} className={styles.modalHint}>
                        Loading the member's SOR…
                    </Text>
                ) : null}
            </div>
        </Modal>
    );
}

export default MemberSorModal;
